const regex = new RegExp(/\{\{([a-zA-Z0-9\.]+)\}\}/g);

export const evaluateTextTemplating = (text: string, objects: { [key: string]: any }): string => {
  return text.replaceAll(regex, (_match, p1) => {
    const path = p1.split(".");

    const result = path.reduce(
      (acc: { [key: string]: any }, current: string) => (acc && acc[current]) || null,
      objects,
    );

    if (typeof result === "string" || typeof result === "number" || typeof result === "bigint") {
      return `${result}`;
    }
    return "";
  });
};
